module.exports = __webpack_public_path__ + "r-v3/img/pause.962fd3b1.svg";